import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { ProjectElementType } from "@planzone/dto";

import { SecureContextualMenu } from "@common/secureContextualMenu";
import { clip } from "@common/clipeable";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function Timestamp({ task }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.timestamp}>
      <div className={styles.contextualMenu}>
        <SecureContextualMenu
          context={{ task }}
          items={[
            {
              name: t("projectPage.tasksContextualMenu.copyUrl"),
              useCase: UseCases.retrieveTask,
              act: () => clip(`${location.origin}/tasks/${task.uuid}`, null),
            },
            {
              name: t("projectPage.tasksContextualMenu.duplicate"),
              useCase: UseCases.createTask,
              act: () =>
                pushView({
                  data: { project: task.project, list: task.list, task },
                  key: UseCases.createTask,
                }),
            },
            {
              name: t("projectPage.tasksContextualMenu.move"),
              useCase: UseCases.moveListElement,
              act: () =>
                pushView({
                  key: UseCases.moveListElement,
                  data: {
                    projectElementId: task.uuid,
                    projectElementType: ProjectElementType.TASK,
                    currentParentList: task.list,
                    project: task.project,
                  },
                }),
            },
            {
              name: t("projectPage.tasksContextualMenu.remove"),
              useCase: UseCases.removeTask,
              color: "#DB5F63FF",
              act: () => pushView({ key: UseCases.removeTask, data: task }),
            },
          ]}
        />
      </div>
    </div>
  );
}

export { Timestamp };
